import { Component, Input, inject } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { AppService } from '@services/app.services';
import { ConfigurationService } from '@services/configuration.service';

import { ModalComponent } from '@shared/modal/modal.component';

// @dynamic
@Component({
    selector: 'checkout-partner-exclusivity-error-modal',
    templateUrl: 'partner-exclusivity-error-modal.component.html',
    styleUrls: ['partner-exclusivity-error-modal.component.scss'],
    standalone: true,
    imports: [ModalComponent],
})
export class PartnerExclusivityErrorModalComponent extends ModalComponent {
    @Input() public partner: string;
    @Input() public isExpiredCart: boolean = false;
    public modalRef: ModalService;

    title: string = 'Aïe !';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_offre_exclusive_partener',
        categorieClic: 'Modale_error',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_error',
    };

    private configurationService = inject(ConfigurationService);
    private appService = inject(AppService);

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.appService.navigateTo('/panier');
        });
    }

    public goToWall(): void {
        this.appService.navigateTo(this.configurationService.getData()?.global.wall.plan);
    }
}
